import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { OpenGraphMetadata } from './opengraphio.types';

@Injectable()
export class OpengraphioService {
  endPoint: string;
  apiKey: string;

  constructor(/* private http: HttpClient, private protocolDroidService: ProtocolDroidService */) {
    /* this.endPoint = environment.opengraphio.endPoint || '';
    this.apiKey = environment.opengraphio.apiKey || ''; */
    this.endPoint = '';
    this.apiKey = '';
  }

  public getOpenGraphMetaData(_url: string): Observable<OpenGraphMetadata> {
    return of({ title: 'Title', description: 'Description' } as OpenGraphMetadata);

    // Deactivated for now
    /*  return this.http.get(this.endPoint + encodeURIComponent(url), { params: { app_id: this.apiKey } }).pipe(
      map((res: any) => {
        if (res.error && res.error.code === 101) {
          return {
            title: 'API Limitation',
            description: 'Cannot display metadata'
          };
        } else if (res.error) {
          throw new Error(res.error.message);
        } else {
          return res.openGraph;
        }
      }),
      catchError((error: any) => {
        console.error(error.message);
        return of({
          title: this.protocolDroidService.translate('misc.modals.error-title', 'Oops...'),
          description: this.protocolDroidService.translate('misc.errors.unknown-short', 'Unknown Error')
        });
      })
    ); */
  }
}
